import { LitElement, html } from 'lit-element';
import alertEvents from './alert-events';

class AlertDeleteButton extends LitElement {
	static get properties() {
		return {
			id: { type: Number },
		};
	}

	onButtonClick() {
		const detail = {
			id: this.id,
		};

		const event = new CustomEvent(alertEvents.ALERT_DELETE, {
			bubbles: true,
			detail,
		});

		this.dispatchEvent(event);
	}

	render() {
		return html`
			<div class="manageable-list__item-button">
				<button class="button button--ghost button--icon-only button--small" @click="${this.onButtonClick}">
					<span class="button__icon">
						<x-icon icon="delete"></x-icon>
					</span>
				</button>
			</div>`;
	}

	createRenderRoot() {
		return this;
	}
}

customElements.define('x-alert-delete-button', AlertDeleteButton);

export default AlertDeleteButton;
